export enum CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES {
  SURVEY = 'survey',
  ORG_UNIT = 'orgUnit',
  OWNER = 'owner',
}
